import React from "react";
import DeliveryLogs from "./DeliveryLogs";
import MeetingService from "../../../services/MeetingService";

const SmsLogs = () => (
  <DeliveryLogs
    title="SMS Logs"
    getLogs={MeetingService.getSmsLogs}
    getReport={MeetingService.getSmsLogReport}
  />
);

export default SmsLogs;
